import { throttle } from 'lodash';
import { useEffect } from 'react';

import MapBox from '../../../../components/map/MapBox.ts';

export const useResizeMap = ({
  mapContainerRef,
  mapRef,
}: {
  mapContainerRef: React.RefObject<HTMLDivElement>;
  mapRef: React.RefObject<MapBox | null>;
}) => {
  useEffect(() => {
    if (!mapContainerRef.current) return undefined;

    const resizeMap = throttle(() => mapRef.current?.resize(), 550);

    const resizeObserver = new ResizeObserver(resizeMap);
    resizeObserver.observe(mapContainerRef.current);

    return () => resizeObserver.disconnect();
  }, [mapContainerRef, mapRef]);
};
